import angular, { ICompileService, IOnInit } from "angular";
import {
  RecordDataSource,
  RecordDataSourceLegacy,
} from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { StringFilter } from "../../../records/grids/columns/filters/subFilters/StringFilter";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import angularGridValueGetters from "../../../utils/AngularGrid/valueGetters";
import { FormViewController } from "../../../records/forms/formView/controller";

type rowCommandEventArgs = {
  name: string;
  data: any;
  form: FormViewController;
};

export interface SelectMachinePartModalControllerConfig {
  onSelect: (args: rowCommandEventArgs) => void;
}

export class SelectMachinePartModalController implements IOnInit {
  static $inject = [
    ServerUtilityName,
    ColumnDefinitionServiceName,
    GridSettingsServiceName,
    "$compile",
    "$element",
  ];

  allPartGridDataSource!: RecordDataSource;
  machinePartGridDataSource!: RecordDataSource;
  showAllParts: boolean = false;

  readonly machinePartGridcolumns: ColDef[];
  readonly allPartGridcolumns: ColDef[];
  readonly gridSettings: IGridSettings;

  machine!: any;
  resolve!: {
    machine: any;
    config: SelectMachinePartModalControllerConfig;
  };
  modalInstance!: angular.ui.bootstrap.IModalInstanceService;

  constructor(
    private readonly serverUtility: ServerUtility,
    columnDefinitionService: ColumnDefinitionService,
    gridSettingsService: GridSettingsService,
    $compile: ICompileService,
    private readonly $element: JQLite
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      Symbol("selectMachinePartModal")
    );
    this.machinePartGridcolumns = [
      {
        headerName: "Select",
        template: `<i class="fa fa-plus-circle text-primary" ng-click="$emit('command', {data, commandName:'select'})"></i>`,
        width: 20,
        suppressSorting: true,
      },
      columnDefinitionService.getNumberColDef({ field: "PartId", hide: true }),
      columnDefinitionService.getNumberColDef({
        header: "Part Number",
        field: "PartNumber",
        valueGetter: angularGridValueGetters.byPath("Part.PartNumber"),
        filter: new FilterProvider("PartNumber", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartNumberContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Manufacturer",
        field: "PartManufacturerName",
        valueGetter: angularGridValueGetters.byPath(
          "Part.PartManufacturer.Name"
        ),
        filter: new FilterProvider("PartManufacturerName", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartManufacturerNameContains"],
            })
          )
          .getGridFilterFactory(),

        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Cabinet",
        field: "CabinetType",
        valueGetter: angularGridValueGetters.byPath("Part.CabinetType"),
        filter: new FilterProvider("CabinetType", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["CabinetTypeContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Description",
        field: "PartDescription",
        valueGetter: angularGridValueGetters.byPath("Part.PartDescription"),
        filter: new FilterProvider("PartDescription", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartDescriptionContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Keyword",
        field: "PartKeywordName",
        valueGetter: angularGridValueGetters.byPath("Part.PartKeyword.Name"),
        filter: new FilterProvider("PartKeywordName", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartKeywordNameContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Status",
        field: "Status",
        valueGetter: angularGridValueGetters.byPath("Part.Status"),
        suppressMenu: true,
        suppressSorting: true,
      }),
    ];

    this.allPartGridcolumns = [
      {
        headerName: "Select",
        template: `<i class="fa fa-plus-circle text-primary" ng-click="$emit('command', {data, commandName:'select'})"></i>`,
        width: 20,
        suppressSorting: true,
      },
      columnDefinitionService.getNumberColDef({ field: "Id", hide: true }),
      columnDefinitionService.getNumberColDef({
        header: "Part Number",
        field: "PartNumber",
        filter: new FilterProvider("PartNumber", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartNumberContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Manufacturer",
        field: "PartManufacturerName",
        valueGetter: angularGridValueGetters.byPath("PartManufacturer.Name"),
        filter: new FilterProvider("PartManufacturerName", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartManufacturerNameContains"],
            })
          )
          .getGridFilterFactory(),

        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Cabinet",
        field: "CabinetType",
        filter: new FilterProvider("CabinetType", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["CabinetTypeContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Description",
        field: "PartDescription",
        filter: new FilterProvider("PartDescription", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartDescriptionContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Keyword",
        field: "PartKeywordName",
        valueGetter: angularGridValueGetters.byPath("PartKeyword.Name"),
        filter: new FilterProvider("PartKeywordName", $compile)
          .addFilter(
            "contains",
            new StringFilter({
              displayName: "contains",
              queryFieldNames: ["PartKeywordNameContains"],
            })
          )
          .getGridFilterFactory(),
        suppressSorting: true,
      }),
      columnDefinitionService.getNumberColDef({
        header: "Status",
        field: "Status",
        suppressMenu: true,
        suppressSorting: true,
      }),
    ];
  }

  $onInit(): void {
    this.machine = this.resolve.machine;
    const machineId = this.machine.Id;
    this.machinePartGridDataSource = new RecordDataSourceLegacy(
      this.serverUtility,
      `/api/machines/${machineId}/appliedPartsQuery`
    );
    this.allPartGridDataSource = new RecordDataSourceLegacy(
      this.serverUtility,
      `/api/parts`
    );
    this.$element.parent().css("width", "950px");
  }

  onItemCommand(args: rowCommandEventArgs, showAllParts: boolean) {
    var SelectedPart = showAllParts
      ? { ...args.data, PartId: args.data.Id, QuantityOnHand: Number.MAX_VALUE }
      : { ...args.data.Part, QuantityOnHand: args.data.Quantity };
    this.resolve.config?.onSelect(SelectedPart);
  }
}
